import React, { useState, useEffect, useContext, useRef } from "react";
import { getDataWithToken } from "../../services/GetDataService";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TablePagination from "@mui/material/TablePagination";
import Skeleton from "@mui/material/Skeleton";
import IconButton from "@mui/material/IconButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Link } from "react-router-dom";
import TableChartIcon from "@mui/icons-material/TableChart";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import PulseLoader from "react-spinners/PulseLoader";
import { useSnackbar } from "notistack";
import axios from "axios";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import { AuthContext } from "../../context/AuthContext";
import { Box, Collapse, Tooltip } from "@mui/material";
import Grid from "@mui/material/Grid2";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import FilterListIcon from "@mui/icons-material/FilterList";
import SearchIcon from "@mui/icons-material/Search";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Slide from "@mui/material/Slide";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import AddInvestment from "./AddInvestment";
import UpdateInvestment from "./UpdateInvestment";
import Chip from "@mui/material/Chip";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const InvestmentList = () => {
  const { login, unity_fund_admin_panel, logout } = useContext(AuthContext);
  const [tableDataList, setTableDataList] = useState([]);
  const [page, setPage] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [investmentId, setInvestmentId] = useState("");
  const [status, setStatus] = useState("");
  const [minAmount, setMinAmount] = useState(null);
  const [maxAmount, setMaxAmount] = useState(null);
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [startingTime, setStartingTime] = useState(null);
  const [endingTime, setEndingTime] = useState(null);

  const customeTextFeild = {
    "& label": {
      fontSize: "11px",
    },
    "& label.Mui-focused": {
      color: "#0F1624",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {
      padding: "8px 12px",
    },
    "& .MuiOutlinedInput-root": {
      fontSize: "13px",
      "& fieldset": {
        borderRadius: "8px",
      },
      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };

  const custopDatePickerFeild = {
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
    background: "#ffffff",
    "& .MuiInputBase-root": {
      fontSize: "0.875rem",
      height: "2.5rem",
    },
    "& label.Mui-focused": {
      color: "#E5E5E5",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {},
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#",
      },
      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialog(false);
    setDeleteData({});
  };

  const handleDeleteDialog = (i, row) => {
    setDeleteData({ index: i, row: row });
    setDeleteDialog(true);
  };

  const pageLoading = () => {
    let content = [];
    let loadingNumber = 10;

    if (
      unity_fund_admin_panel?.user?.permission?.includes("update_investment")
    ) {
      loadingNumber = loadingNumber + 1;
    }
    if (
      unity_fund_admin_panel?.user?.permission?.includes("delete_investment")
    ) {
      loadingNumber = loadingNumber + 1;
    }
    for (let i = 0; i < 10; i++) {
      content.push(
        <TableRow key={i}>
          {[...Array(loadingNumber).keys()].map((e, i) => (
            <TableCell key={i}>
              <Skeleton></Skeleton>
            </TableCell>
          ))}
        </TableRow>
      );
    }
    return content;
  };

  const handleDelete = async () => {
    try {
      setLoading2(true);
      let response = await axios({
        url: `/api/v1/investment/delete/${deleteData.row._id}`,
        method: "delete",
      });
      if (response?.status === 401) {
        logout();
        return;
      }
      if (response.status >= 200 && response.status < 300) {
        handleSnakbarOpen("Deleted successfully", "success");
        getData();
      }
      setDeleteDialog(false);
      setLoading2(false);
    } catch (error) {
      console.log("error", error);
      setLoading2(false);
      handleSnakbarOpen(
        error.response?.data?.message?.toString() ||
          "Error deleting investment",
        "error"
      );
      setDeleteDialog(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    console.log("newPage", newPage);
    getData(newPage);
    setPage(newPage);
  };

  const clearFilter = (event) => {
    console.log("clearFilter");
    setInvestmentId("");
    setStatus("");
    setMinAmount("");
    setMaxAmount("");
    setStartingTime(null);
    setEndingTime(null);
    setPage(0);
    const newUrl = `/api/v1/investment?limit=${rowsPerPage}&page=1`;
    getData(0, rowsPerPage, newUrl);
  };

  const handleChangeRowsPerPage = (event) => {
    console.log("event.target.value", event.target.value);
    setRowsPerPage(parseInt(event.target.value, rowsPerPage));
    getData(0, event.target.value);
    setPage(0);
  };

  const getData = async (pageNO, limit, newUrl) => {
    setLoading(true);
    let newPageNO = page;
    let url;
    if (pageNO >= 0) {
      newPageNO = pageNO;
    }
    let newLimit = rowsPerPage;
    if (limit) {
      newLimit = limit;
    }
    if (newUrl) {
      url = newUrl;
    } else {
      let newStatus = status;
      let newMinAmount = minAmount;
      let newMaxAmount = maxAmount;
      let newStartingTime = "";
      let newEndingTime = "";
      if (status === "None") {
        newStatus = "";
      }
      if (minAmount === null) {
        newMinAmount = "";
      }
      if (maxAmount === null) {
        newMaxAmount = "";
      }
      if (startingTime !== null) {
        newStartingTime = dayjs(startingTime).format("YYYY-MM-DD");
      }
      if (endingTime !== null) {
        newEndingTime = dayjs(endingTime).format("YYYY-MM-DD");
      }

      url = `/api/v1/investment?investment_id=${investmentId.trim()}&startDate=${newStartingTime}&endDate=${newEndingTime}&minAmount=${newMinAmount}&maxAmount=${newMaxAmount}&status=${newStatus}&limit=${newLimit}&page=${
        newPageNO + 1
      }`;
    }
    let allData = await getDataWithToken(url);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setTableDataList(allData?.data?.data);
      setTotalData(allData?.data?.totalData);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setLoading(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Grid container columnSpacing={3} style={{ padding: "24px 0" }}>
        <Grid size={9}>
          <Typography
            variant="h6"
            gutterBottom
            component="div"
            sx={{ color: "#0F1624", fontWeight: 600 }}
          >
            Investment List
          </Typography>
        </Grid>
        <Grid size={3} style={{ textAlign: "right" }}>
          <AddInvestment getData={getData} />
        </Grid>
      </Grid>
      <div
        style={{
          background: "#fff",
          border: "1px solid #EAECF1",
          borderRadius: "12px",
          overflow: "hidden",
          padding: "16px 0",
          boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
        }}
      >
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          sx={{ px: 1.5, mb: 1.75 }}
        >
          <Grid size={2}>
            <Typography
              variant="h6"
              gutterBottom
              component="div"
              sx={{ color: "#0F1624", fontWeight: 600, margin: 0 }}
            >
              Details
            </Typography>
          </Grid>
          <Grid size={10}>
            <Box sx={{ flexGrow: 1 }}>
              <Grid
                container
                justifyContent="right"
                alignItems="center"
                spacing={1}
              >
                <Grid size={2}>
                  <TextField
                    sx={{ ...customeTextFeild }}
                    id="investment_id"
                    fullWidth
                    size="small"
                    variant="outlined"
                    label="Investment ID"
                    value={investmentId}
                    onChange={(e) => setInvestmentId(e.target.value)}
                  />
                </Grid>

                <Grid size={2}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Start Date"
                      sx={{
                        width: "100%",
                        ...custopDatePickerFeild,
                      }}
                      format="DD/MM/YYYY"
                      maxDate={dayjs()}
                      value={startingTime}
                      onChange={(newValue) => setStartingTime(newValue)}
                      slotProps={{
                        textField: {
                          size: "small",
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid size={2}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="End Date"
                      sx={{
                        width: "100%",
                        ...custopDatePickerFeild,
                      }}
                      format="DD/MM/YYYY"
                      maxDate={dayjs()}
                      value={endingTime}
                      onChange={(newValue) => setEndingTime(newValue)}
                      slotProps={{
                        textField: {
                          size: "small",
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid size={1.5}>
                  <TextField
                    sx={{ ...customeTextFeild }}
                    id="min_amount"
                    fullWidth
                    size="small"
                    variant="outlined"
                    label="Min Amount"
                    type="number"
                    value={minAmount || ""}
                    onChange={(e) => setMinAmount(e.target.value || null)}
                    onWheel={(e) => e.target.blur()}
                  />
                </Grid>
                <Grid size={1.5}>
                  <TextField
                    sx={{ ...customeTextFeild }}
                    id="max_amount"
                    fullWidth
                    size="small"
                    variant="outlined"
                    label="Max Amount"
                    type="number"
                    value={maxAmount || ""}
                    onChange={(e) => setMaxAmount(e.target.value || null)}
                    onWheel={(e) => e.target.blur()}
                  />
                </Grid>
                <Grid size={1.5}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={{ ...customeTextFeild }}
                  >
                    <InputLabel id="demo-status-outlined-label">
                      Status
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="demo-status-outlined-label"
                      id="demo-status-outlined"
                      label="Status"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <MenuItem value="None">None</MenuItem>
                      <MenuItem value={true}>Active</MenuItem>
                      <MenuItem value={false}>Inactive</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid size={1.5}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={{ lg: 1, xl: 1 }}>
                      <Grid size={4}>
                        <Button
                          fullWidth
                          variant="outlined"
                          color="info"
                          disableElevation
                          size="small"
                          sx={{ py: "4px" }}
                          onClick={clearFilter}
                        >
                          <RestartAltIcon />
                        </Button>
                      </Grid>
                      <Grid size={8}>
                        <Button
                          fullWidth
                          variant="contained"
                          disableElevation
                          color="info"
                          sx={{ py: "4px" }}
                          size="small"
                          startIcon={<SearchIcon />}
                          onClick={(event) => handleChangePage(event, 0)}
                        >
                          Search
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <div
          style={{
            overflowX: "auto",
            minWidth: "100%",
            width: "Calc(100vw - 385px)",
            boxSizing: "border-box",
          }}
        >
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell style={{ whiteSpace: "nowrap" }}>Document</TableCell>
                <TableCell style={{ whiteSpace: "nowrap" }}>
                  Investment ID
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap" }}>
                  Investment Date
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap" }}>Users</TableCell>
                <TableCell style={{ whiteSpace: "nowrap" }}>Amount</TableCell>
                <TableCell style={{ whiteSpace: "nowrap" }}>Profit</TableCell>
                <TableCell style={{ whiteSpace: "nowrap" }}>
                  Investment Duration
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap" }}>
                  Company Name
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap" }}>
                  Company Mobile
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap" }}>Status</TableCell>
                {(unity_fund_admin_panel?.user?.permission?.includes(
                  "update_investment"
                ) ||
                  unity_fund_admin_panel?.user?.permission?.includes(
                    "delete_investment"
                  )) && (
                  <TableCell align="right" style={{ whiteSpace: "nowrap" }}>
                    Actions
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {!loading &&
                tableDataList.length > 0 &&
                tableDataList.map((row, i) => (
                  <TableRow key={row?._id}>
                    <TableCell sx={{ whiteSpace: "nowrap" }}>
                      {row?.document?.url ? (
                        <Button
                          variant="outlined"
                          size="small"
                          color="info"
                          onClick={() =>
                            window.open(
                              row.document.url,
                              "_blank",
                              "noopener,noreferrer",
                            )
                          }
                        >
                          View Document
                        </Button>
                      ) : (
                        "-------"
                      )}
                    </TableCell>
                    <TableCell>{row?.investment_id}</TableCell>
                    <TableCell>
                      {row?.investment_date
                        ? dayjs(row.investment_date).format("YYYY-MM-DD")
                        : "-------"}
                    </TableCell>
                    <TableCell>
                      {row?.user_data && row.user_data.length > 0 ? (
                        <Tooltip
                          arrow
                          placement="top"
                          title={
                            <Box
                              component="ul"
                              sx={{
                                m: 0,
                                pl: 2,
                                py: 0.5,
                                maxWidth: 280,
                              }}
                            >
                              {row.user_data.map((user) => (
                                <Box
                                  component="li"
                                  key={user?._id}
                                  sx={{ fontSize: "13px", lineHeight: 1.6 }}
                                >
                                  {user?.name || "Unknown"}
                                  {user?.mobile ? ` (${user.mobile})` : ""}
                                </Box>
                              ))}
                            </Box>
                          }
                        >
                          <Box
                            sx={{
                              display: "inline-flex",
                              flexWrap: "wrap",
                              gap: 0.5,
                              cursor: "pointer",
                            }}
                          >
                            {row.user_data.slice(0, 2).map((user, idx) => (
                              <Chip
                                key={user?._id || idx}
                                label={user?.name || "Unknown"}
                                size="small"
                                sx={{ fontSize: "11px", height: "24px" }}
                              />
                            ))}
                            {row.user_data.length > 2 && (
                              <Chip
                                label={`+${row.user_data.length - 2}`}
                                size="small"
                                sx={{ fontSize: "11px", height: "24px" }}
                              />
                            )}
                          </Box>
                        </Tooltip>
                      ) : (
                        "-------"
                      )}
                    </TableCell>
                    <TableCell>
                      {row?.amount ? parseFloat(row.amount).toFixed(2) : "0.00"}
                    </TableCell>
                    <TableCell>
                      {row?.profit ? parseFloat(row.profit).toFixed(2) : "0.00"}
                    </TableCell>
                    <TableCell>
                      {row?.investment_duration_days
                        ? `${row.investment_duration_days} days`
                        : "-------"}
                    </TableCell>
                    <TableCell>
                      {row?.company_name ? row.company_name : "-------"}
                    </TableCell>
                    <TableCell>
                      {row?.company_mobile ? row.company_mobile : "-------"}
                    </TableCell>
                    <TableCell>
                      {row?.status ? (
                        <>
                          <TaskAltOutlinedIcon
                            style={{
                              color: "#10ac84",
                              height: "16px",
                              position: "relative",
                              top: "4px",
                            }}
                          />{" "}
                          <span
                            style={{
                              color: "#10ac84",
                            }}
                          >
                            Active &nbsp;
                          </span>
                        </>
                      ) : (
                        <>
                          <HighlightOffOutlinedIcon
                            style={{
                              color: "#ee5253",
                              height: "16px",
                              position: "relative",
                              top: "4px",
                            }}
                          />
                          <span
                            style={{
                              color: "#ee5253",
                            }}
                          >
                            Inactive
                          </span>
                        </>
                      )}
                    </TableCell>
                    {(unity_fund_admin_panel?.user?.permission?.includes(
                      "update_investment"
                    ) ||
                      unity_fund_admin_panel?.user?.permission?.includes(
                        "delete_investment"
                      )) && (
                      <TableCell align="right">
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 1,
                          }}
                        >
                          {unity_fund_admin_panel?.user?.permission?.includes(
                            "update_investment"
                          ) && (
                            <UpdateInvestment
                              clearFilter={clearFilter}
                              row={row}
                            />
                          )}
                          {unity_fund_admin_panel?.user?.permission?.includes(
                            "delete_investment"
                          ) && (
                            <IconButton
                              onClick={() => handleDeleteDialog(i, row)}
                              color="error"
                            >
                              <DeleteOutlineIcon />
                            </IconButton>
                          )}
                        </Box>
                      </TableCell>
                    )}
                  </TableRow>
                ))}

              {!loading && tableDataList.length < 1 ? (
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell colSpan={15} style={{ textAlign: "center" }}>
                    <strong> {message}</strong>
                  </TableCell>
                </TableRow>
              ) : null}
              {loading && pageLoading()}
            </TableBody>
          </Table>
        </div>
        {tableDataList.length > 0 ? (
          <div>
            <TablePagination
              style={{ display: "block", border: "none" }}
              rowsPerPageOptions={[]}
              count={totalData}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        ) : (
          <br />
        )}
      </div>
      <Dialog
        open={deleteDialog}
        onClose={handleDeleteDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div style={{ padding: "10px", minWidth: "300px" }}>
          <DialogTitle id="alert-dialog-title">{"Are you sure?"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              You want to delete investment{" "}
              <b>{deleteData?.row?.investment_id} </b>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteDialogClose}>cancel</Button>
            <Button
              variant="contained"
              disabled={loading2}
              onClick={handleDelete}
              style={{ minWidth: "100px", minHeight: "35px" }}
              autoFocus
              disableElevation
            >
              <PulseLoader
                color={"#4B46E5"}
                loading={loading2}
                size={10}
                speedMultiplier={0.5}
              />{" "}
              {loading2 === false && "Confirm"}
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </>
  );
};

export default InvestmentList;
